/**
 * Paths of the intake app (sb-facturatie-intake, repo sb-finance) as framed by pages/Projecten.tsx.
 * Route is /alle-projecten, NOT /projecten: Traefik's sb-projects router (Streamlit,
 * PathPrefix(`/project`)) is a plain string prefix and would catch /projecten before this SPA.
 */
export const PROJECTEN_ROUTE = '/alle-projecten';
export const INTAKE_PREFIX = '/intake/';
export const INTAKE_DEFAULT_PAGE = '/intake/projecten';

/** Frame source from the ?p= deep link; only same-origin /intake/ paths, else the list. */
export function intakeSrc(search: string): string {
  const p = new URLSearchParams(search).get('p');
  if (p && p.startsWith(INTAKE_PREFIX) && !p.includes('..') && !p.includes('\\')) {
    return p;
  }
  return INTAKE_DEFAULT_PAGE;
}

/** Address-bar URL that reopens the platform page on the framed intake path. */
export function projectenUrl(framePath: string): string {
  return framePath === INTAKE_DEFAULT_PAGE
    ? PROJECTEN_ROUTE
    : `${PROJECTEN_ROUTE}?p=${encodeURIComponent(framePath)}`;
}
